<template>
  <div class="navbar-fixed-content" style="padding-top: 70px">
    <my-account-header></my-account-header>

    <div class="myinfo-bottom">
      <div class="cnt">
        <my-side-menu></my-side-menu>
        <div class="myinfo-con">
          <div class="tabbable-line">
            <ul class="nav nav-tabs">
              <li class="active">
                <a class="a-tab" data-status="1" data-toggle="tab">课程</a>
              </li>
            </ul>

            <div class="tab-content">
              <div class="tab-pane active" id="tab_1_1">
                <div class="opr"></div>
                <div class="join-t-list">
                  <div class="media-join-item" v-for="item in courseLists">
                    <img class="media-object" :src="item.thumb" />
                    <span class="media-con-r">
                      <h4 class="media-heading">{{ item.title }}</h4>
                      <span class="media-summary">{{ item.summary }}</span>
                      <span class="media-num">
                        <span class="ks">
                          已学
                          <span>{{ item.progress }}</span> 段
                        </span>
                        <span class="media-num">
                          <span class="ks">
                            已学时间：
                            <span>{{ item.progressTime }} 分钟 </span>
                          </span>
                        </span>
                        <span class="media-num">
                          <span class="ks">
                            已学课时：
                            <span>{{ item.hour }} 课时 </span>
                          </span>
                        </span>
                        <a
                          class="tn-continue"
                          @click="getPlayUrl(item)"
                          target="_blank"
                          >继续学习</a
                        >
                      </span>
                    </span>
                  </div>
                </div>
                <div
                  class="row"
                  style="with；100%;height:50px;margin-top:20px;"
                >
                  <!-- v-if="query_data.PageIndex*query_data.MaxResultCount< query_data.totalCount" -->
                  <div
                    class="col-md-12 loading-more"
                    style="with；100%;height:50px;"
                    v-if="
                      query_data.MaxResultCount * query_data.PageIndex <
                      query_data.totalCount
                    "
                    @click="loadMore()"
                  >
                    加载更多
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyAccountHeader from "@/layout/MyAccountHeader";
import MySideMenu from "@/layout/MySideMenu";
import comFun from "@/common/common";
export default {
  components: {
    MyAccountHeader,
    MySideMenu,
  },
  data() {
    return {
      query_data: {
        stopajax: !1,
        MaxResultCount: 10,
        PageIndex: 0,
        totalCount: 0,
        index: 0,
        SkipCount: 0,
      },
      courseLists: [],
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    nav() {
      return this.$store.state.nav;
    },
  },
  // created() {
  //   this.getMyCourseList(this.query_data).then(res=>{ this.courseLists = res.items});
  // },
  mounted() {
    this.loadMore();
  },
  methods: {
    loadMore() {
      // 获取全部
      comFun.getMyCourseList(this.query_data).then((res) => {
        var _index = this.courseLists.length;
        this.courseLists = this.courseLists.concat(res.items);
        res.items.forEach((element, i) => {
          this.getHour(element, _index + i);
        });

        this.query_data.totalCount = res.totalCount;
        if (
          this.query_data.PageIndex * this.query_data.MaxResultCount <
          this.query_data.totalCount
        ) {
          this.query_data.PageIndex = this.query_data.PageIndex + 1;
        } else {
          this.query_data.stopajax = 1;
        }
      });
    },
    getHour(item, index) {
      var rate = 45;
      if (item.classId > 0) {
        comFun.getMyClassNumber(item.classId).then((res) => {
          if (res.success) {
            if (res.result.success == "true") {
              rate = res.result.rate;
            }
          }
          this.courseLists[index].hour = (item.progressTime / rate).toFixed(1);
          this.$set(this.courseLists, index, this.courseLists[index]);
        });
      } else {
        this.courseLists[index].hour = (item.progressTime / rate).toFixed(1);
      }
    },
    getPlayUrl(item) {
      this.$router.push({
        name: "CourseDetail",
        query: {
          id: item.id,
        },
      });
    },
  },
};
</script>